export const dailyAnalyticsFetch = (params) => {
  return (dispatch) => {
    dispatch({ type: "DAILY_ANALYTICS_FETCH", payload: params });
  };
};

export const weeklyAnalyticsFetch = (params) => {
  return (dispatch) => {
    dispatch({ type: "WEEKLY_ANALYTICS_FETCH", payload: params });
  };
};

export const monthlyAnalyticsFetch = (params) => {
  return (dispatch) => {
    dispatch({ type: "MONTHLY_ANALYTICS_FETCH", payload: params });
  };
};
